import { useEffect, useState } from 'react';
import { getStatusForProvideData } from 'src/api/getStatusForProvideData';
import { BRAND_LOCATION_STORAGE_KEY } from 'src/constans/branding';
import { useGetChatId } from 'src/hooks/chatId';
import { UserInfoStateResponse } from 'src/models/UserInfoState';

export const useBrandLocation = () => {
  const { currentChatId } = useGetChatId();
  const [brandLocation, setBrandLocation] = useState<string | null>(
    localStorage.getItem(BRAND_LOCATION_STORAGE_KEY),
  );

  useEffect(() => {
    if (!currentChatId) {
      return;
    }

    getStatusForProvideData(currentChatId)
      .then(res => res.json())
      .then((res: UserInfoStateResponse) => {
        const nextLocation = res?.location || null;
        if (nextLocation) {
          localStorage.setItem(BRAND_LOCATION_STORAGE_KEY, nextLocation);
        } else {
          localStorage.removeItem(BRAND_LOCATION_STORAGE_KEY);
        }
        setBrandLocation(nextLocation);
      })
      .catch(() => {
        // keep the last known branding fallback from localStorage
      });
  }, [currentChatId]);

  return { brandLocation };
};
